import React from 'react';

// Lazy load components for code splitting
export const ProductTabsNavigation = React.lazy(
  () => import('./ProductTabsNavigation')
);
export const CmsCard = React.lazy(() => import('./CmsCard'));
export const CmsGrid = React.lazy(() => import('./CmsGrid'));
export const CmsKpiGrid = React.lazy(() => import('./CmsKpiGrid'));
export const CmsKpiTile = React.lazy(() => import('./CmsKpiTile'));
export const CustomReactComponent = React.lazy(
  () => import('./CustomReactComponent')
);
export const CmsDataDefinitionIcon = React.lazy(
  () => import('./CmsDataDefinitionIcon')
);
export const CmsLineChart = React.lazy(() => import('./CmsLineChart'));
export const CmsBarChart = React.lazy(() => import('./CmsBarChart'));
export const CmsHorizontalProgressBarList = React.lazy(
  () => import('./CmsHorizontalProgressBarList')
);
export const CmsPieChart = React.lazy(() => import('./CmsPieChart'));
export const CmsListV2 = React.lazy(() => import('./CmsListV2'));
export const CmsGaugeChart = React.lazy(() => import('./CmsGaugeChart'));

export { CmsSwitcher } from './CmsSwitcher';
// Export wrapper separately (not lazy loaded as it provides context)
export { ProductWrapper } from './ProductTabsNavigation';

// Export types
export * from './types';

// Export context
export { TabContext, useTabContext } from './TabContext';

// Export CMS data types
export type { CmsDataProps } from './CmsDataContext';

// Export data fetching wrapper
export { default as DataFetchingWrapper } from './DataFetchingWrapper';
export type { DataFetchConfig } from './DataFetchingWrapper';
